import React, { FormEvent, useCallback, useState } from "react";

export interface FormFields {
  name?: string;
  email?: string;
  phone?: string;
  terms?: string;
  submit?: string;
  consent?: string;
  enquiry?: string;
  message?: string;
  privacyLink?: string;
  title?: string;
  smallprint?: string;
}

export const SignUpForm: React.FC<{
  formControlInfo: FormFields;
}> = ({ formControlInfo }) => {
  const [email, setEmail] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  const subscribeToMailingList = useCallback(
    (e: FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      fetch(
        `https://mindshift.us19.list-manage.com/subscribe/post?u=4e8e9d65db0428c3101608c59&id=ae5d3f11e1&EMAIL=${email}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
        .then((response) => {
          setShowMessage(true);
          setEmail("");
          return response.json();
        })
        .catch((error) => {
          console.log(error);
          setShowMessage(true);
          setEmail("");
        });
    },
    [email]
  );

  return (
    <form
      className="validate text-white"
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      onSubmit={subscribeToMailingList}
    >
      <p className="pb-20px">{formControlInfo.title}</p>
      {!showMessage && (
        <>
          <label htmlFor="email">{formControlInfo.email}</label>
          <div className="flex items-end justify-between border-b-2 border-lazer pb-5px">
            <input
              id="email"
              type="email"
              placeholder="example@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required={true}
              className="p3 w-5/6 border-0 bg-transparent p-0 text-lazer placeholder-lazer"
            />
            <button
              type="submit"
              className="p3 flex-grow text-white lg:pb-5px"
              value="Subscribe"
              name="subscribe"
            >
              {formControlInfo.submit}
            </button>
          </div>
          <p className="smallprint pt-20px">{formControlInfo.smallprint}</p>
          <div className="mt-10px w-full">
            <label htmlFor="gdpr_4217">{formControlInfo.consent}</label>
            <input
              id="gdpr_4217"
              name="gdpr[4217]"
              type="checkbox"
              required={true}
              value="Y"
              className="ml-10px border-lazer bg-transparent text-lazer"
            />
          </div>
        </>
      )}

      {showMessage && (
        <p className="p3 text-lazer">{formControlInfo.message}</p>
      )}
      <div className="smallprint mt-10px">
        <p>
          {formControlInfo.terms}
          <a
            href="https://mailchimp.com/legal/"
            className="text-lazer underline"
          >
            {formControlInfo.privacyLink}
          </a>
        </p>
      </div>
    </form>
  );
};
